import { FOCUS_STOP_WORDS } from "./runsSummaryConstants"
import type { RunsSummaryFocus } from "./runsSummaryTypes"

function addFocusTerm(terms: Set<string>, value: string): void {
  const normalized = value.trim().toLowerCase()
  if (normalized.length < 3 || FOCUS_STOP_WORDS.has(normalized)) {
    return
  }
  terms.add(normalized)
}

export function parseRunsSummaryFocusText(
  focusText: string | null | undefined,
): RunsSummaryFocus {
  const rawText = (focusText ?? "").trim()
  const terms = new Set<string>()

  rawText.split(/[,;\n]/).forEach((part) => addFocusTerm(terms, part))
  rawText
    .match(/[A-Za-z0-9][A-Za-z0-9_.:/-]{2,}/g)
    ?.forEach((token) => addFocusTerm(terms, token))

  return {
    hasFocus: rawText.length > 0,
    terms: [...terms],
  }
}

export function focusTextMatches(
  value: string | null | undefined,
  focus: RunsSummaryFocus,
): boolean {
  if (!focus.hasFocus || focus.terms.length === 0 || !value) {
    return false
  }
  const normalized = value.toLowerCase()
  return focus.terms.some((term) => normalized.includes(term))
}
